import { render, staticRenderFns } from "./huiyuanmiandan.vue?vue&type=template&id=4a842f4f"
import script from "./huiyuanmiandan.vue?vue&type=script&lang=js"
export * from "./huiyuanmiandan.vue?vue&type=script&lang=js"
import style0 from "./huiyuanmiandan.vue?vue&type=style&index=0&id=4a842f4f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports